module.exports = __webpack_public_path__ + "img/close.40e187ae.svg";